<div class="story-interactive-container">

  <!-- Left: Story with highlights -->
  <div class="story-panel" [class.sidebar-open]="sidebarVisible">
    <div class="story-text">
      <ng-container *ngFor="let segment of segments">
        <span *ngIf="!segment.isHighlighted">{{ segment.text }}</span>
        <span *ngIf="segment.isHighlighted"
              class="highlight {{ segment.highlightClass }}"
              (click)="onSegmentClick(segment)"
              [title]="segment.ambiguity?.id || ''">{{ segment.text }}</span>
      </ng-container>
    </div>

    <!-- Summary bar -->
    <div class="summary-bar" *ngIf="ambiguities.length > 0">
      <span class="summary-text">{{ summaryText }}</span>
    </div>
  </div>

  <!-- Right: Sidebar detail -->
  <div class="detail-sidebar" *ngIf="sidebarVisible">
    <div class="sidebar-header">
      <span class="sidebar-title" *ngIf="selectedAmbiguity">
        {{ selectedAmbiguity.id }}
      </span>
      <button class="btn-close" (click)="closeSidebar()">&times;</button>
    </div>

    <!-- Ambiguity detail -->
    <div class="sidebar-section" *ngIf="selectedAmbiguity">
      <label class="section-label">Domanda</label>
      <p class="section-content">{{ selectedAmbiguity.clarification_needed }}</p>

      <label class="section-label">Testo nel documento</label>
      <p class="section-content source-text">"{{ selectedAmbiguity.source }}"</p>

      <label class="section-label">Impatto</label>
      <p class="section-content text-muted">{{ selectedAmbiguity.impact }}</p>
    </div>

    <!-- Resolution detail -->
    <div class="sidebar-section" *ngIf="selectedResolution">
      <label class="section-label">
        Risposta proposta
        <span class="badge ml-1" [ngClass]="getConfidenceClass(selectedResolution.confidence)">
          {{ selectedResolution.confidence | uppercase }}
        </span>
      </label>

      <div class="resolution-text" *ngIf="!editingPatch">
        <p>{{ selectedResolution.user_action === 'modified'
               ? selectedResolution.user_modified_text
               : selectedResolution.proposed_text }}</p>
      </div>

      <!-- Edit mode -->
      <div class="resolution-edit" *ngIf="editingPatch">
        <textarea class="form-control" rows="4" [(ngModel)]="editText"></textarea>
        <div class="edit-actions mt-2">
          <button class="btn btn-sm btn-primary mr-1" (click)="saveEdit()">Salva</button>
          <button class="btn btn-sm btn-outline-secondary" (click)="editingPatch = false">Annulla</button>
        </div>
      </div>

      <!-- Sources -->
      <div class="sources-section" *ngIf="selectedResolution.sources?.length > 0">
        <label class="section-label">Fonte</label>
        <div class="source-card" *ngFor="let src of selectedResolution.sources">
          <span class="source-filename">{{ src.file_name }}</span>
          <p class="source-evidence" *ngIf="src.evidence_quote">
            "{{ src.evidence_quote.length > 200
                 ? src.evidence_quote.substring(0, 200) + '...'
                 : src.evidence_quote }}"
          </p>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="sidebar-actions"
           *ngIf="!selectedResolution.user_action || selectedResolution.user_action === 'pending'">
        <button class="btn btn-sm btn-success mr-1" (click)="approveResolution()">Approva</button>
        <button class="btn btn-sm btn-primary mr-1" (click)="startEdit()">Modifica</button>
        <button class="btn btn-sm btn-outline-danger" (click)="rejectResolution()">Rifiuta</button>
      </div>

      <!-- Status display -->
      <div class="resolution-status" *ngIf="selectedResolution.user_action && selectedResolution.user_action !== 'pending'">
        <span *ngIf="selectedResolution.user_action === 'approved'" class="status-badge status-approved">Approvata</span>
        <span *ngIf="selectedResolution.user_action === 'modified'" class="status-badge status-modified">Modificata</span>
        <span *ngIf="selectedResolution.user_action === 'rejected'" class="status-badge status-rejected">Rifiutata</span>
      </div>
    </div>

    <!-- No resolution (unresolved ambiguity) -->
    <div class="sidebar-section" *ngIf="!selectedResolution && selectedAmbiguity">
      <div class="unresolved-notice">
        Nessuna risposta trovata nella Knowledge Base per questa ambiguita'.
      </div>
    </div>
  </div>

  <!-- Footer: History navigation -->
  <div class="history-bar" *ngIf="hasTurns">
    <button class="btn btn-sm btn-outline-secondary"
            [disabled]="!canGoPrevious"
            (click)="previousTurn()">
      &lt;
    </button>
    <span class="turn-label">{{ currentTurnDisplay }}</span>
    <button class="btn btn-sm btn-outline-secondary"
            [disabled]="!canGoNext"
            (click)="nextTurn()">
      &gt;
    </button>
  </div>

</div>
